import React from 'react'
import { Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import PartnersCard from '../../components/Partners/PartnersCard.jsx'
import { getPaginationInfo, processError } from '../../lib/lib'
import api from '../../api/api'
// import Filter from '../../components/UI/Filter.jsx'
import Pagination from 'react-js-pagination'
import { CaretLeft, CaretRight } from "phosphor-react"
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton.jsx'
const cookies = new Cookies()

class Partners extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 6,
            totalProjects: 0,
            projects: [],
            render: [],
            filters: [],
            paginationRange: 5,
            options: ['type'],
            sort: 'type',
            totalItems: 0,
            types: [],
            projectsLoaded: false,
            dataLoaded: false,
        }
        this.squaresFour = this.squaresFour.bind(this)
        this.squaresTwo = this.squaresTwo.bind(this)
        this.addToFilters = this.addToFilters.bind(this)
        this.updateFilters = this.updateFilters.bind(this)
        this.changePage = this.changePage.bind(this)
        this.getProjects = this.getProjects.bind(this)
        this.updateCheckboxes = this.updateCheckboxes.bind(this)
        this.updateProjects = this.updateProjects.bind(this)
    }

    changePage(page) {
        this.setState({ projectsLoaded: false })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page, limit: this.state.limit })
        const filters = this.state.filters
        const sort = this.state.sort
        this.getProjects({ token, lang, start, end, filters, sort }).then(({ rows }) => this.setState({ projectsLoaded: true, projects: rows, render: rows, page }))
    }

    updateFilters(name, value) {
        return new Promise((resolve, reject) => {
            try {
                let filters = this.state.filters
                const names = filters.map((filter) => filter.name)
                if (!filters.length) {
                    resolve([{ name, values: [value] }])
                } else if (!names.includes(name) && filters.length) {
                    filters.push({ name, values: [value] })
                    resolve(filters)
                } else {
                    filters.forEach((filter, filterIndex) => {
                        if (filter.name === name) {
                            if (!filter.values.includes(value)) {
                                filter.values.push(value)
                            } else {
                                const vlueIndex = filter.values.indexOf(value)
                                filter.values.splice(vlueIndex, 1)
                                if (!filter.values.length) filters.splice(filterIndex, 1)
                            }
                        }
                    })
                    resolve(filters)
                }
            } catch (e) {
                reject(e)
            }
        })
    }

    updateCheckboxes(e) {
        const types = this.state.types.map((type) => type.type === e.target.value ? { type: type.type, count: type.count, checked: e.target.checked } : type)
        this.setState({ types })
    }

    addToFilters(name, value) {
        this.setState({ projectsLoaded: false })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page: 1, limit: this.state.limit })
        this.updateFilters(name, value).then((filters) => {
            const sort = this.state.sort
            this.getProjects({ start, end, lang, token, filters, sort }).then(({ rows, count }) => this.setState({ projectsLoaded: true, totalItems: count, filters, render: rows, page: 1 }))
        })
    }

    updateProjects(data) {
        api.getProjects(data)
            .then(({ rows, count }) => this.setState({ totalItems: count, render: rows, page: 1, sort: data.sort }))
            .catch((e) => processError(e, this.props.history))
    }

    getProjects(data) {
        return new Promise((resolve, reject) => {
            api.getProjects(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page: this.state.page, limit: this.state.limit })
        const sort = this.state.sort
        let arrPromise = [
            this.getProjects({ token, lang, start, end, sort }).then(({ rows, count, total }) => {
                total.map((filter) => filter.checked = false)
                this.setState({ projectsLoaded: true, projects: rows, render: rows, totalItems: count, types: total })
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    squaresFour(event) {
        event.preventDefault()
        const squaresFour = document.getElementById('squaresFour')
        const squaresTwo = document.getElementById('squaresTwo')
        const cards = document.getElementsByClassName('catalog-card')
        for (let i = 0; i < cards.length; i++) {
            cards[i].classList.remove('col-xl-12', 'col-lg-12', 'col-md-12', 'wide')
            cards[i].classList.add('col-xl-4', 'col-lg-6', 'col-md-6')
        }
        squaresTwo.classList.remove('active')
        squaresFour.classList.add('active')
    }

    squaresTwo(event) {
        event.preventDefault()
        const squaresFour = document.getElementById('squaresFour')
        const squaresTwo = document.getElementById('squaresTwo')
        const cards = document.getElementsByClassName('catalog-card')
        for (let i = 0; i < cards.length; i++) {
            cards[i].classList.remove('col-xl-4', 'col-lg-6', 'col-md-6')
            cards[i].classList.add('col-xl-12', 'col-lg-12', 'col-md-12', 'wide')
        }
        squaresFour.classList.remove('active')
        squaresTwo.classList.add('active')
    }

    render() {
        const { t } = this.props
        return (
            <div className="content news-bg position-relative">
                <Row className="w-100 m-0">
                    <Col xs={12} md={12} className="p-0">
                        <div className="page-title">
                            <div className="float-left">
                                <h1 className="title news-dashboard text-lowercase xl-font-size">{t('partners-projects')}</h1>
                            </div>
                        </div>

                        {/* {
                            this.state.dataLoaded ?
                                <Filter
                                    types={this.state.types}
                                    updateCheckboxes={this.updateCheckboxes}
                                    addToFilters={this.addToFilters}
                                    squaresFour={this.squaresFour}
                                    squaresTwo={this.squaresTwo}
                                    updateItems={this.updateProjects}
                                    options={this.state.options}
                                    filters={this.state.filters}
                                    page={Number(this.state.page)}
                                    limit={this.state.limit}
                                    lang={this.props.i18n.language}
                                    token={cookies.get('accessToken')}
                                />
                                :
                                <Filter skeleton={true} />
                        } */}

                        <div className="col-xl-12">
                            <section>
                                <div className="content-body news-bg">
                                    {' '}
                                    <Row className="px-15">
                                        {
                                            this.state.projectsLoaded ?
                                                this.state.render.map((item) => (
                                                    <PartnersCard key={item.id}
                                                        id={item.id}
                                                        image={item.image}
                                                        title={item.title}
                                                        desc={item.desc}
                                                        type={item.type}
                                                        typeId={item.typeId}
                                                        url={item.url}
                                                        filters={this.state.filters}
                                                        props={this.props}
                                                    />
                                                ))
                                                :
                                                <React.Fragment>
                                                    <PartnersCard skeleton={true} />
                                                    <PartnersCard skeleton={true} />
                                                    <PartnersCard skeleton={true} />
                                                </React.Fragment>
                                        }
                                    </Row>
                                    {
                                        this.state.dataLoaded ?
                                            this.state.totalItems > this.state.limit ?
                                                <Row className="pagination-row">
                                                    <Pagination
                                                        activePage={Number(this.state.page)}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalItems}
                                                        pageRangeDisplayed={this.state.paginationRange}
                                                        onChange={this.changePage.bind(this)}
                                                        itemClass={'page-item'}
                                                        disabledClass={'disabled'}
                                                        activeClass={'active'}
                                                        activeLinkClass={'active'}
                                                        linkClass={'page-link'}
                                                        itemClassFirst={'d-none'}
                                                        itemClassLast={'d-none'}
                                                        linkClassPrev={'arrow'}
                                                        linkClassNext={'arrow'}
                                                        nextPageText={<CaretRight size={16} />}
                                                        prevPageText={<CaretLeft size={16} />}
                                                    />
                                                </Row> : ''
                                            :
                                            <Row className="pagination-row">
                                                <Skeleton className="d-block mx-auto" width={200} height={30} />
                                            </Row>
                                    }
                                </div>
                            </section>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Partners.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Partners)



// WEBPACK FOOTER //
// ./src/views/Partners/Partners.jsx